module.exports = __webpack_public_path__ + "media/images/iamdpcl-5940f1de68b35a46a5c4e316de802c06.svg";